import IRoute from "./interfaces/IRoute";

import {t} from 'react-multi-lang';
import EvaluateContainer from "./containers/EvaluateContainer";
import ExportContainer from "./containers/ExportContainer";
import ImportContainer from "./containers/ImportContainer";
import LogoutContainer from "./containers/LogoutContainer";
import NoteContainer from "./containers/NoteContainer";
import OverviewContainer from "./containers/OverviewContainer";
import WelcomeContainer from "./containers/WelcomeContainer";

function getRoutes(): IRoute[] {
    return [
        {
            component: WelcomeContainer,
            display: false,
            name: t('welcome.welcome'),
            url: '/welcome',
        },
        {
            component: ImportContainer,
            display: true,
            name: t('import.import'),
            url: '/import',
        },
        {
            component: OverviewContainer,
            display: true,
            name: t('overview.overview'),
            url: '/overview',
        },
        {
            component: EvaluateContainer,
            display: false,
            name: t('evaluate.evaluate'),
            url: '/evaluate',
        },
        {
            component: NoteContainer,
            display: true,
            name: t('note.note'),
            url: '/notes',
        },
        {
            component: ExportContainer,
            display: true,
            name: t('export.export'),
            url: '/export',
        },
        {
            component: LogoutContainer,
            display: true,
            name: t('logout.logout'),
            url: '/logout',
        }
    ]
}

export default getRoutes;


// WEBPACK FOOTER //
// ./src/routes.tsx